<template>
    <div class="withdrawal-record" id="withdrawaltitle">
      <div class="lowerview">
        <div class="centerview">
          <el-row>
            <el-col :span="21">
              <ul class="search-form">
                <li class="search-inputs-row">
                  <div class="input-group">
                    <el-input
                      placeholder="提现单号"
                      v-model="withdrawal_id_input"
                      clearable
                      style="width: 200px; margin-right: 10px;"
                    ></el-input>
                    <el-input
                      placeholder="用户手机号"
                      v-model="phone_input"
                      clearable
                      style="width: 200px;"
                    ></el-input>
                  </div>
                </li>
                
                <li>
                  <el-select
                    v-model="status_input"
                    clearable
                    style="width: 140px"
                    placeholder="提现状态"
                  >
                    <el-option
                      v-for="(value, key) in statusMap"
                      :key="key"
                      :label="value"
                      :value="key"
                    ></el-option>
                  </el-select>
                </li>
                
                <li>
                  <el-date-picker
                    v-model="starttime_value"
                    type="datetime"
                    style="width: 200px"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="开始时间"
                  ></el-date-picker>
                </li>
                <li>
                  <el-date-picker
                    v-model="endtime_value"
                    type="datetime"
                    placeholder="结束时间"
                    style="width: 200px"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </li>
              </ul>
            </el-col>
            <el-col :span="3">
              <ul class="action-buttons">
                <!-- 钱包资金可用余额显示 -->
                <li class="fund-pool-item" style="margin-bottom: 0;">
                  <el-button
                    type="info"
                    class="fund-pool-button"
                    @click="showFundPoolDialog = true"
                    style="width: 100%; height: 40px;"
                  >
                    <span class="button-content">
                      <span class="button-text">钱包资金</span>
                      <span class="balance-amount">¥{{ formatFundPool(fundPool) }}</span>
                    </span>
                  </el-button>
                </li>
                <li>
                  <el-button
                    type="primary"
                    class="querybutton search"
                    @click="querybtnClick()"
                    style="width: 100%; height: 40px;"
                    >查询</el-button
                  >
                </li>
                <!-- <li>
                  <el-button
                    type="success"
                    class="exportbutton"
                    @click="exportbtnClick()"
                    :disabled="exportPrivilege == 1"
                    >导出</el-button
                  >
                </li> -->
              </ul>
            </el-col>
          </el-row>
        </div>
      <div class="bottomviewtwo">
          <el-table
            :data="tableData"
            :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
            :summary-method="getSummaries"
            show-summary
            style="width: 100%"
          >
            <el-table-column
              align="left"
              prop="phone_number"
              label="手机号"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="left"
              prop="withdrawal_id"
              label="提现单号"
              :show-overflow-tooltip="true"
              width="180"
            ></el-table-column>
            <el-table-column
              align="left"
              prop="amount"
              label="提现金额"
              :formatter="formatAmount"
            ></el-table-column>
            <el-table-column
              align="left"
              prop="status"
              label="提现状态"
              :formatter="formatStatus"
            ></el-table-column>
            <el-table-column
              align="left"
              prop="apply_time"
              label="申请时间"
              :show-overflow-tooltip="true"
              width="180"
            ></el-table-column>
            <el-table-column
              align="left"
              prop="complete_time"
              label="完成时间"
              :show-overflow-tooltip="true"
              width="180"
            ></el-table-column>
            <!-- <el-table-column
              align="left"
              prop="bank_name"
              label="银行名称"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="left"
              prop="bank_account"
              label="银行账号"
              :show-overflow-tooltip="true"
              width="180"
            ></el-table-column> -->
            <el-table-column
              align="left"
              prop="remark"
              label="备注"
              :show-overflow-tooltip="true"
            ></el-table-column>
  
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <!-- 根据后端返回的状态码0（待审核）调整审核按钮条件 -->
                <div v-if="scope.row.status == 0" class="audit-buttons">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleWithdrawal(scope.row.withdrawal_id, 'approve')"
                  >审核通过</el-button>
                  <el-button
                    type="danger"
                    size="mini"
                    @click="handleWithdrawal(scope.row.withdrawal_id, 'reject')"
                  >审核拒绝</el-button>
                </div>
                <span v-else>--</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="cutpagesview">
          <el-pagination
            class="pageinclass"
            background
            :page-size="pagesize"
            :page-count="pagecount"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="prev, pager, next,jumper"
            :total="total"
          ></el-pagination>
        </div>

        <!-- 钱包资金余额对话框 -->
        <el-dialog
          title="钱包资金可用余额"
          :visible.sync="showFundPoolDialog"
          width="520px"
          center
          :close-on-click-modal="false"
          class="fund-pool-dialog"
        >
          <div class="fund-pool-dialog-content">
            <div class="fund-pool-info">
              <div class="info-section">
                <h4 class="section-title">统计方式</h4>
                <el-radio-group v-model="fundPoolType" class="radio-group">
                  <el-radio label="default" class="custom-radio">默认统计</el-radio>
                  <el-radio label="custom" class="custom-radio">自定义时间</el-radio>
                </el-radio-group>
              </div>
              
              <div v-if="fundPoolType === 'custom'" class="info-section time-section">
                <h4 class="section-title">查询时间范围</h4>
                <div class="time-display">
                  <span class="time-label">开始时间：</span>
                  <span class="time-value">{{ starttime_value || '未选择' }}</span>
                </div>
                <div class="time-display">
                  <span class="time-label">结束时间：</span>
                  <span class="time-value">{{ endtime_value || '未选择' }}</span>
                </div>
              </div>
              
              <div class="info-section balance-section">
                <h4 class="section-title">资金信息</h4>
                <div class="balance-display">
                  <div class="balance-item">
                    <span class="balance-label">可用余额：</span>
                    <span class="balance-amount large">¥{{ formatFundPool(fundPool) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <span slot="footer" class="dialog-footer">
            <el-button 
              @click="showFundPoolDialog = false" 
              size="medium"
              class="dialog-button"
            >关 闭</el-button>
          </span>
        </el-dialog>

        
        <!-- 审核对话框 -->
        <el-dialog
          :title="dialogTitle"
          :visible.sync="auditDialogVisible"
          width="400px"
          center
          :close-on-click-modal="false"
          :before-close="handleDialogClose"
        >
          <div class="audit-dialog-content">
            <div class="audit-info">
              <div class="info-item">
                <span class="label">提现单号：</span>
                <span class="value">{{ currentWithdrawalData ? currentWithdrawalData.withdrawal_id : '' }}</span>
              </div>
              <div class="info-item">
                <span class="label">提现金额：</span>
                <span class="value">¥{{ currentWithdrawalData ? currentWithdrawalData.amount : '0.00' }}</span>
              </div>
              <div class="info-item">
                <span class="label">申请人：</span>
                <span class="value">{{ currentWithdrawalData ? currentWithdrawalData.phone_number : '' }}</span>
              </div>
            </div>
            
            <div class="audit-reason" v-if="auditAction === 'reject'">
          <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入拒绝原因"
                v-model="rejectReason"
                maxlength="200"
                show-word-limit
              ></el-input>
            </div>
            
            <!-- 加载过渡画面 -->
            <div v-if="auditLoading" class="audit-loading">
              <el-icon class="is-loading">
                <Loading />
              </el-icon>
              <span class="loading-text">正在处理中，请稍候...</span>
            </div>
          </div>
          
          <span slot="footer" class="dialog-footer">
            <el-button 
              @click="handleDialogClose" 
              size="small"
              :disabled="auditLoading"
            >取 消</el-button>
            <el-button 
              type="primary" 
              @click="handleAuditConfirm()"
              :disabled="(auditAction === 'reject' && !rejectReason) || auditLoading"
              :loading="auditLoading"
              size="small"
            >
              确 定
            </el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>
  
  <script>
  import { transformStringTime } from "../../filters/index.js";
  import API_ROOT from "../../../config/dev.env";
  
  export default {
    name: "WithdrawalRecordData",
    data() {
      return {
        total: 0,
        pagesize: 10,
        currentPage: 1,
        pagecount: 1,
        statistics: [],
        starttime_value: "",
        endtime_value: "",
        withdrawal_id_input: "",
        phone_input: "",
        status_input: "",
        
        
        // withdrawal_type: "",
        // withdrawalTypeList: [
        //   { value: "wallet", label: "钱包提现" },
        //   { value: "income", label: "收益提现" }
        // ],
        
        tableData: [],
        pickerOptions: {
          disabledDate: (time) => {
            return (
              time.getTime() < this.start_date || time.getTime() > Date.now()
            );
          },
        },
        exportPrivilege: 1,
        
        // 状态映射
        statusMap: {
          0: '待审核',
          1: '提现成功',
          2: '审核通过,提现中',
          3: '审核拒绝'
        },
        
        // 钱包资金
        fundPool: 0,                    // 钱包资金可用余额
        showFundPoolDialog: false,      // 显示资金余额对话框
        fundPoolType: 'default',        // 资金统计类型：default-默认统计，custom-自定义时间


        // 审核相关
        auditDialogVisible: false,
        currentWithdrawalData: null,
        auditAction: '',
        rejectReason: '',
        dialogTitle: '',
        auditLoading: false,  // 审核加载状态
        
        // 异步处理相关状态
        asyncProcessing: false,      // 是否异步处理中
        currentTaskId: null,         // 当前任务ID
        pollingInterval: null,       // 轮询定时器
        pollingCount: 0,             // 轮询次数
        maxPollingCount: 30,         // 最大轮询次数（约3分钟）
        pollingDelay: 3000           // 轮询间隔（3秒）
      };
    },
    
    beforeRouteEnter(to, from, next) {
      window.document.body.style.backgroundColor = "#efefef";
next();
    },
    
    beforeRouteLeave(to, from, next) {
      window.document.body.style.backgroundColor = "#001928";
      next();
    },
  
    mounted() {
      this.checkExportPrivilege();
      this.$nextTick(function () {
        this.defaultTime();
this.querybtnClick();
      });
    },

  methods: {
checkExportPrivilege() {
      let role = this.$store.state.role || [];
      for (let i in role) {
        if (role[i].view_name == "经营分析") {
          for (let j in role[i].chlid) {
            if (role[i].chlid[j].view_name == "提现记录") {
              for (let m in role[i].chlid[j].method) {
                if (role[i].chlid[j].method[m].method_name == "导出提现记录") {
                  this.exportPrivilege = 0;
                }
              }
            }
          }
        }
      }
    },

    defaultTime() {
      var d = new Date();
      let start_date = d.getFullYear() + "-" + 
        this.checkTime(d.getMonth() + 1) + "-" + 
        this.checkTime(d.getDate()) + " 00:00:00";
      this.starttime_value = start_date;
      this.start_date = start_date;

      var d1 = new Date();
      let end_date = d1.getFullYear() + "-" + 
        this.checkTime(d1.getMonth() + 1) + "-" + 
        this.checkTime(d1.getDate()) + " " + 
        this.checkTime(d1.getHours()) + ":" + 
        this.checkTime(d1.getMinutes()) + ":" + 
        this.checkTime(d1.getSeconds());
      this.endtime_value = end_date;
    },

    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },

    handleSizeChange(val) {},
    
    handleCurrentChange(val) {
this.currentPage = val;
      this.querybtnClick(String(val));
    },

    querybtnClick(page) {
      this.tableData = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        fundPoolType: this.fundPoolType,
        action: "getWithdrawalRecord"
      };
if (page) params.page = page;

      // if (this.withdrawal_type) params.withdrawal_type = this.withdrawal_type;
      if (this.status_input) params.status = this.status_input;
      if (this.withdrawal_id_input) params.withdrawal_id = this.withdrawal_id_input;
if (this.phone_input) params.phone_number = this.phone_input;
      
      if (this.starttime_value && this.endtime_value) {
        if (this.starttime_value > this.endtime_value) {
          this.$message.warning("结束日期时间不能小于开始日期时间");
          return;
        }
        params.start_time = this.starttime_value;
        params.end_time = this.endtime_value;
      }

      this.$api({
        method: "post",
        url: "/api.php/paymentRecord/index",
        data: params,
        transformRequest: [(data) => {
          let ret = "";
          for (let it in data) {
            ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
          }
          return ret;
        }],
      })
      .then((su) => {
        if (su.data.code == 1) {
          this.tableData = su.data.data || [];
          this.statistics = su.data;
          
          // 更新钱包资金可用余额
          if (su.data.fund_pool !== undefined) {
            this.fundPool = su.data.fund_pool;
          }
          
          if (!page) {
            this.currentPage = 1;
            this.total = parseInt(su.data._count || 0);
            this.pagecount = su.data.page_count || 1;
          }
        } else if (su.data.code == 300) {
          this.handleSessionExpired(su.data.message);
        } else if (su.data.code == 304) {
          this.tableData = [];
          this.total = 0;
          this.pagecount = 1;
          this.$message.warning("未查询到提现记录");
        } else {
          this.$message.warning(su.data.message || "查询失败");
        }
      })
      .catch((err) => {
        console.error("查询提现记录错误:", err);
        this.$message.error("网络错误，请稍后重试");
      });
    },

    // 格式化资金余额
    formatFundPool(amount) {
      return amount ? parseFloat(amount).toFixed(2) : '0.00';
    },


    formatAmount(row, column, cellValue) {
      return cellValue ? '¥' + parseFloat(cellValue).toFixed(2) : '¥0.00';
    },

    formatStatus(row, column, cellValue) {
      return this.statusMap[cellValue] || '未知状态';
    },

    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      const backendData = this.statistics;

      columns.forEach((col, index) => {
        if (index === 0) {
          sums[index] = '总合计';
          return;
        }

        if (col.property === 'amount') {
          const totalAmount = backendData.amount || 0;
          sums[index] = '¥' + parseFloat(totalAmount).toFixed(2);
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },

    handleWithdrawal(withdrawalId, action) {
      this.currentWithdrawalData = this.tableData.find(item => item.withdrawal_id === withdrawalId);
      this.auditAction = action;
      this.rejectReason = '';
      this.dialogTitle = action === 'approve' ? '审核通过' : '审核拒绝';
      this.auditDialogVisible = true;
    },

    handleAuditConfirm() {
      if (!this.currentWithdrawalData) return;
      
      // 重置异步处理状态
      this.resetAsyncState();
      
      // 设置加载状态
this.auditLoading = true;
      
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        withdrawal_id: this.currentWithdrawalData.withdrawal_id,
        action: this.auditAction
      };
      
      if (this.auditAction === 'reject') {
        params.reject_reason = this.rejectReason;
      }

      this.$api({
        method: "post",
        url: "/api.php/paymentRecord/index",
        data: params,
        transformRequest: [(data) => {
          let ret = "";
          for (let it in data) {
            ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
          }
          return ret;
        }],
      })
      .then((su) => {
        if (su.data.code == 200) {
          // 同步处理完成
          this.handleAuditSuccess();
        } else if (su.data.code == 202) {
          // 异步处理中，显示提示框并开始轮询状态
          this.handleAsyncProcessing(su.data);
        } else if (su.data.code == 300) {
          this.handleSessionExpired(su.data.message);
        } else {
          this.handleAuditError(su.data.message || '操作失败');
        }
      })
      .catch((err) => {
        this.handleAuditError("网络错误，请稍后重试");
        console.error("审核操作错误:", err);
      });
    },

    exportbtnClick() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
  
      // 移除省份、城市、场站参数
      // if (this.province_value) params.province = this.province_value;
      // if (this.city_value) params.city = this.city_value;
      // if (this.station_value) params.station_id = this.station_value;
      // 移除提现类型参数
      // if (this.withdrawal_type) params.withdrawal_type = this.withdrawal_type;
      if (this.status_input) params.status = this.status_input;
      if (this.withdrawal_id_input) params.withdrawal_id = this.withdrawal_id_input;
      if (this.phone_input) params.phone_number = this.phone_input;
      
      if (this.starttime_value && this.endtime_value) {
        if (this.starttime_value > this.endtime_value) {
          this.$message.warning("结束日期时间不能小于开始日期时间");
          return;
        }
        params.start_time = this.starttime_value;
        params.end_time = this.endtime_value;
      }
  
      this.$api({
        method: "post",
        url: "/api.php/withdrawalRecord/export",
        data: params,
        transformRequest: [(data) => {
          let ret = "";
          for (let it in data) {
            ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
          }
return ret;
        }],
      })
      .then((su) => {
        if (su.data.code == 1 && su.data.url) {
          this.createAndDownloadFile(su.data.url);
          this.$message.success('导出成功');
        } else {
          this.$message.warning(su.data.message || '导出失败');
        }
      })
      .catch((err) => {
        console.error("导出错误:", err);
        this.$message.error("导出失败，请稍后重试");
      });
    },

    // 处理对话框关闭
    handleDialogClose(done) {
      if (this.asyncProcessing) {
        this.$confirm('处理仍在进行中，关闭对话框不会中断处理，确定要关闭吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auditDialogVisible = false;
          if (done) done();
        }).catch(() => {
          // 用户取消关闭
        });
      } else {
        this.auditDialogVisible = false;
        if (done) done();
      }
    },
    createAndDownloadFile(content) {
      let link = document.createElement("a");
      let contentArr = content.split("/");
      contentArr[0] = JSON.parse(API_ROOT.API_ROOT);
      content = contentArr[0] + "/" + contentArr[1] + "/" + contentArr[2] + "/" + contentArr[3];
      link.href = content;
      link.click();
    },

    handleSessionExpired(message) {
      localStorage.clear();
      this.$router.push("/login");
      this.$message.warning(message || "登录已过期，请重新登录");
    },
// 处理异步处理响应
    handleAsyncProcessing(responseData) {
      this.asyncProcessing = true;
      this.currentTaskId = responseData.data.task_id;
      
      // 关闭审核对话框
      this.auditDialogVisible = false;
      this.auditLoading = false;
      
      // 显示异步处理提示框
      this.$message({
        message: '系统正在处理中，请稍候...',
        type: 'info',
        duration: 0, // 持续显示
        showClose: true
      });
      
      // 开始轮询状态
      this.startStatusPolling();
    },

    // 显示异步处理状态
    showAsyncProcessingStatus(taskData) {
      // 可以在这里显示异步处理的详细信息
      console.log('异步处理开始，任务ID:', this.currentTaskId, '任务数据:', taskData);
    },

    // 开始状态轮询
    startStatusPolling() {
      this.pollingCount = 0;
      this.pollingInterval = setInterval(() => {
        this.pollTaskStatus();
      }, this.pollingDelay);
    },

    // 轮询任务状态
    async pollTaskStatus() {
      if (this.pollingCount >= this.maxPollingCount) {
        this.handlePollingTimeout();
        return;
      }

      this.pollingCount++;

      try {
        const response = await this.$api({
          method: "post",
          url: "/api.php/paymentRecord/index",
          data: {
            uid: localStorage.getItem("uid"),
            token: localStorage.getItem("token"),
            action: "check_refund_status",
            task_id: this.currentTaskId
          },
          transformRequest: [(data) => {
          let ret = "";
          for (let it in data) {
            ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
          }
          return ret;
        }],
        });

        const result = response.data;
        
        if (result.code === 200) {
          // 任务完成
          this.handleTaskCompleted(result);
        } else if (result.code === 202) {
          // 任务仍在处理中，继续轮询
          this.updateProcessingStatus(result.data);
        } else {
          // 任务失败
          this.handleTaskFailed(result);
        }
      } catch (error) {
        console.error('轮询任务状态失败:', error);
        // 网络错误不影响轮询继续
      }
    },

    // 处理任务完成
    handleTaskCompleted(result) {
      this.clearPollingInterval();
      // 关闭提示框
      this.$message.closeAll();
      this.handleAuditSuccess();
      this.$message.success('处理完成');
    },

    // 处理任务失败
    handleTaskFailed(result) {
      this.clearPollingInterval();
      // 关闭提示框
      this.$message.closeAll();
      this.handleAuditError(result.message || '处理失败');
      this.$message.error(result.message || '处理失败');
    },

    // 处理轮询超时
    handlePollingTimeout() {
      this.clearPollingInterval();
      // 关闭提示框
      this.$message.closeAll();
      this.handleAuditError('处理超时，请稍后查看结果');
      this.$message.warning('处理超时，请稍后查看结果');
    },

    // 更新处理状态
    updateProcessingStatus(taskData) {
      // 可以在这里更新处理状态信息
      console.log('处理进度更新:', taskData);
    },

    // 重置异步状态
    resetAsyncState() {
      this.asyncProcessing = false;
      this.currentTaskId = null;
      this.pollingCount = 0;
      this.clearPollingInterval();
    },

    // 清理轮询定时器
    clearPollingInterval() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },

    // 处理审核成功
    handleAuditSuccess() {
      this.auditLoading = false;
      this.auditDialogVisible = false;
      this.$message.success('退款成功');
      // 传递当前页码，保持用户在当前页面
      this.querybtnClick(String(this.currentPage));
    },

    // 处理审核错误
    handleAuditError(message) {
      this.auditLoading = false;
      this.$message.error(message);
    },

    // 重置异步处理状态
    resetAsyncState() {
      this.clearPollingInterval();
      this.asyncProcessing = false;
      this.currentTaskId = null;
      this.pollingCount = 0;
      this.dialogTitle = this.auditAction === 'approve' ? '审核通过' : '审核拒绝';
    },

    // 清除轮询定时器
    clearPollingInterval() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    beforeDestroy() {
      this.clearPollingInterval();
      // 关闭所有提示框
      this.$message.closeAll();
    },
  }
};
</script>

<style scoped>
.withdrawal-record {
  padding: 20px;
}

.topview {
  margin-bottom: 20px;
}

.top {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.centerview ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.centerview li {
  margin-bottom: 10px;
}

.bottomviewtwo {
  margin-top: 20px;
}

.cutpagesview {
  margin-top: 20px;
  text-align: center;
}

.audit-dialog-content .info-item {
  margin-bottom: 10px;
  display: flex;
}

.audit-dialog-content .label {
  width: 80px;
  color: #666;
}

.audit-dialog-content .value {
  flex: 1;
  color: #333;
}

.audit-reason {
  margin-top: 15px;
}

/* 审核按钮布局 */
.audit-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.audit-buttons .el-button {
  min-width: 70px;
  padding: 6px 8px;
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 审核加载过渡画面 */
.audit-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 4px;
  margin-top: 15px;
}

.audit-loading .el-icon {
  font-size: 24px;
  color: #409eff;
  margin-bottom: 10px;
  animation: rotating 2s linear infinite;
}

.audit-loading .loading-text {
  font-size: 14px;
  color: #606266;
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 异步处理状态样式 */
.async-processing-status {
  text-align: center;
  padding: 20px 0;
}

.processing-info {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.processing-icon {
  font-size: 32px;
  color: #409eff;
  margin-right: 15px;
  animation: rotating 2s linear infinite;
}

.processing-text p {
  margin: 5px 0;
  color: #606266;
}

.processing-tip {
  font-size: 12px;
  color: #909399;
}

.task-info {
  background-color: #f5f7fa;
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 10px;
}

.task-label {
  color: #909399;
  font-size: 12px;
}

.task-value {
  color: #606266;
  font-family: monospace;
  font-size: 12px;
}

/* 钱包资金余额样式 */
.fund-pool-item {
  margin-bottom: 8px;
}

.fund-pool-button {
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #e8e8e8;
  background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
}

.fund-pool-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  background: linear-gradient(135deg, #f0f2f5 0%, #e8eaed 100%);
}

.button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.button-text {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  font-weight: normal;
}

.balance-amount {
  font-size: 16px;
  font-weight: 600;
  color: #5a8dee;
}

.querybutton.search {
  width: 100%;
  border-radius: 6px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #5a8dee 0%, #6d9cf0 100%);
  border: none;
}

.querybutton.search:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(90, 141, 238, 0.25);
  background: linear-gradient(135deg, #6d9cf0 0%, #7ea9f2 100%);
}

/* 钱包资金对话框样式 */
.fund-pool-dialog .el-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.fund-pool-dialog .el-dialog__header {
  background: linear-gradient(135deg, #6d9cf0 0%, #8bb2f2 100%);
  padding: 20px;
  border-bottom: none;
}

.fund-pool-dialog .el-dialog__title {
  color: white;
  font-size: 18px;
  font-weight: 500;
}

.fund-pool-dialog .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.fund-pool-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
  font-size: 18px;
}

.fund-pool-dialog .el-dialog__body {
  padding: 30px;
  background: #fafbfc;
}

.fund-pool-dialog-content {
  padding: 0;
}

.info-section {
  margin-bottom: 20px;
  padding: 18px;
  background: #ffffff;
  border-radius: 8px;
  border-left: 4px solid #8bb2f2;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.info-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 15px;
  font-weight: 500;
  color: #444;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
}

.section-title::before {
  content: "•";
  color: #8bb2f2;
  margin-right: 8px;
  font-size: 18px;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.custom-radio .el-radio__label {
  font-size: 14px;
  color: #666;
}

.custom-radio .el-radio__input.is-checked + .el-radio__label {
  color: #5a8dee;
  font-weight: 500;
}

.time-section {
  background: #f8fafc;
  border-left-color: #7bc47a;
}

.time-section .section-title::before {
  color: #7bc47a;
}

.time-display {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 8px 12px;
  background: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #eee;
}

.time-display:last-child {
  margin-bottom: 0;
}

.time-label {
  font-size: 13px;
  color: #777;
  min-width: 70px;
  font-weight: 500;
}

.time-value {
  font-size: 13px;
  color: #444;
  font-family: 'Courier New', monospace;
  background: #f5f7fa;
  padding: 2px 6px;
  border-radius: 3px;
  flex: 1;
}

.balance-section {
  background: #f8fafc;
  border-left-color: #e6a23c;
}

.balance-section .section-title::before {
  color: #e6a23c;
}

.balance-display {
  text-align: center;
  padding: 10px 0;
}

.balance-item {
  display: inline-block;
  background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
  padding: 15px 25px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
}

.balance-label {
  font-size: 14px;
  color: #777;
  margin-right: 10px;
}

.balance-amount.large {
  font-size: 22px;
  font-weight: 600;
  color: #5a8dee;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.dialog-footer {
  display: flex;
  justify-content: center;
  padding: 20px 30px;
  border-top: 1px solid #eee;
  background: #fafbfc;
}

.dialog-button {
  min-width: 100px;
  border-radius: 6px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  background: #f0f2f5;
  border: 1px solid #ddd;
  color: #666;
}

.dialog-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  background: #e8eaed;
  color: #444;
}

/* 搜索表单布局 */
.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.search-inputs-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.input-group {
  display: flex;
  gap: 10px;
  align-items: center;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 8px;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
}

.action-buttons li {
  margin-bottom: 0;
  flex: 1;
}

/* 钱包资金按钮样式 */
.fund-pool-button {
  height: 40px !important;
  border-radius: 6px !important;
  border: 1px solid #dcdfe6 !important;
  background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%) !important;
  color: #606266 !important;
  font-weight: 500 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 12px !important;
}

.fund-pool-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
  background: linear-gradient(135deg, #f0f2f5 0%, #e8eaed 100%) !important;
  border-color: #c0c4cc !important;
}

.button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
}

.button-text {
  font-size: 12px;
  color: #606266;
  margin-bottom: 2px;
}

.balance-amount {
  font-size: 14px;
  font-weight: 600;
  color: #5a8dee;
}

/* 查询按钮样式 */
.querybutton.search {
  height: 40px !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
}

.querybutton.search:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

/* 整体布局 */
.centerview {
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}

.centerview .el-row {
  align-items: center;
}

/* 调整搜索表单间距 */
.search-form li {
  margin-bottom: 0;
}

/* 确保按钮区域与其他表单元素对齐 */
.action-buttons {
  padding-top: 0;
}

/* 响应式布局 */
@media (max-width: 1200px) {
  .action-buttons {
    flex-direction: column;
  }
  
  .action-buttons li {
    flex: none;
  }
}

/* 搜索表单整体布局 */
.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  padding: 0;
  margin: 0;
}

.search-form li {
  margin: 0;
  padding: 0;
}

/* 输入框和选择器的间距 */
.search-form .el-input,
.search-form .el-select,
.search-form .el-date-picker {
  margin: 0;
}

/* 按钮区域与其他表单的对齐 */
.centerview .el-col:last-child {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 钱包资金按钮内容显示 */
.fund-pool-button .button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

/* 按钮在横向布局中的显示 */
.action-buttons {
  min-height: 40px;
}

/* 确保按钮在不同屏幕尺寸下的显示效果 */
@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
    gap: 10px;
  }
  
  .action-buttons li {
    width: 100%;
  }
}

</style>